<template>
  <div ref="paypalButtonContainer" class="PaypalButton"></div>
</template>

<script>
import { loadScript } from '@paypal/paypal-js'
// import { getDeviceInfo } from "@/utils/utils";

export default {
  name: 'PaypalButton',
  props: {
    amount: {
      type: [String, Number],
      required: true
    },
    currency: {
      type: String,
      default: 'JPY'
    },
    paypalObj: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // deviceInfo: getDeviceInfo(),
      payDetail: {}
    }
  },
  mounted() {
    this.$http.get('paypal/config').then((res) => {
      if (res.data && res.data.data) {
        this.$emit('getPayDetail', res.data.data)
        this.payDetail = res.data.data;
        this.initPayPal()
      }
    })
  },
  methods: {
    async initPayPal() {
      const paypal = await loadScript({
        'currency': 'JPY',
        'client-id': this.payDetail.paypalAppId
      })

      if (!paypal) {
        console.error('PayPal SDK could not be loaded.')
        return
      }

      paypal
        .Buttons({
          createOrder: async (data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    value: this.amount,
                  },
                },
              ],
            })
          },
          onApprove: async (data, actions) => {
            let params = {
              ...this.paypalObj,
              paypalOrderId: data.orderID
            }
            if (this.paypalObj.type !== 'chongzhi') {
              const { paypalFee, paypalRate } = this.payDetail;
              const { rechargeDto } = this.paypalObj;
              const payMoneyJpy = this.amount;
              params = {
                ...params,
                rechargeDto: { ...rechargeDto, payMoneyJpy }
              };
            }
            if (this.paypalObj.type === 'chongzhi') {
              const res = await this.$http.post('paypal/recharge', params)
              if (res.data.code === 200) {
                this.$message.success(this.$t("recharge.rechargeSuccess"))
                this.$emit('success')
              } else {
                this.$message.error(this.$t("cart.paypalError"))
              }
            }
            if (this.paypalObj.type === 'submit') {
              const res = await this.$http.post('paypal/orderBillPay', params)
              if (res.data.code === 200) {
                this.$message.success(this.$t("cart.wslang671"))
                this.$emit('success')
              } else {
                this.$message({
                  message: `paypalOrderId: ${params.paypalOrderId}${this.$t("cart.paypalError")}`,
                  type: 'warning',
                })
              }
            }
            if (this.paypalObj.type === 'zhangdan') {
              const res = await this.$http.post('paypal/containerPay', params)
              if (res.data.code === 200) {
                this.$emit('success');
              } else {
                this.$message.error(this.$t("cart.paypalError"))
              }
            }
          },
          onError: (err) => {
            if (this.paypalObj.type !== "submit") {
              this.$message.error(this.$t("cart.paypalError"))
            }
            console.error('PayPal Checkout onError', err)
          },
          style: {
            layout: 'vertical',
          },
          components: 'buttons',
          funding: {
            allowed: [paypal.FUNDING.CARD],
            disallowed: [paypal.FUNDING.PAYLATER]
          },
        })
        .render(this.$refs.paypalButtonContainer)
    }
  }
}
</script>

<style scoped lang="less">
</style>
